export default __webpack_public_path__ + "static/media/nhl-logo.da5983a4.png";